import { api } from '@/utils/api';
import type { GeoPoint } from '@/utils/geo';

export async function markWorkerJobReached(
  jobApplicationId: string,
  coords: GeoPoint
): Promise<{ success: boolean; alreadyReached?: boolean }> {
  const res = await api.workerMarkedReched(jobApplicationId, {
    lat: coords.lat,
    long: coords.lng,
  });

  if (res?.success) {
    return { success: true };
  }

  if (res?.message === 'Job application not found or already marked as reached') {
    return { success: true, alreadyReached: true };
  }

  return { success: false };
}
